const header = document.getElementById('header');

// Set header height as CSS variable
function setHeaderHeight() {

    const headerHeight = header.offsetHeight + 'px';

    document.documentElement.style.setProperty('--tzo-header-h', headerHeight);

}

if (header) {

    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

}
